import {UPDATE_ADD_SKILL_DETAILS_VALUES, REQUEST_ADD_SKILL_DETAILS, RECEIVE_ADD_SKILL_DETAILS, CLEAR_ADD_SKILL_DETAILS_VALUES} from '../constants/actionTypes';

const addSkillDetailsDataInitialState = {
    activityIdentifier: '',
    activityName: '',
    dataset: '',
    skillName: '',
    activitySpecificData: '',
    scores: 'DoesNotScore',
    removalCandidate: '',

    activityIdentifierValid: false,
    activityNameValid: false,
    datasetValid: false,
    skillNameValid: false,
    activitySpecificDataValid: false,
    scoresValid: false,
    removalCandidateValid: false,

    isAdding: false
};

export const addSkillDetailsData = (state = addSkillDetailsDataInitialState, action) => {
    switch(action.type) {
        case UPDATE_ADD_SKILL_DETAILS_VALUES:
            return {
                ...state,
                ...action.values
            };

        case REQUEST_ADD_SKILL_DETAILS:
            return {
                ...state,
                isAdding: true
            };
        
        case RECEIVE_ADD_SKILL_DETAILS:
            return {
                ...state,
                isAdding: false
            };
        
        case CLEAR_ADD_SKILL_DETAILS_VALUES:
            return addSkillDetailsDataInitialState;
        
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/addSkillDetailsData.js